import { formatCustomDate } from "../../../helpers/dateTools";
import { invoicesTransferTypes } from "./types";

const {
  CLEAR_INVOICES,
  SET_INPUTS,
  GET_INVOICES_TRANSFER,
  SELECT_INVOICE_ID,
  CANCEL_INVOICE_TRANSFER,
  SET_FORM_CANCEL_INVOICE,
  SET_EMAIL_INVOICE,
} = invoicesTransferTypes

const INITIAL_STATE = {
  startDate: formatCustomDate(new Date(), '-'),
  endDate: formatCustomDate(new Date(), '-'),
  stations: [],
  station: null,
  invoicesTransfer: [],
  invoiceId: "",
  formCancelInvoice: false,
  sendEmailInvoice: false,
}

export const invoicesTransferReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case CLEAR_INVOICES:
      return {
        ...state,
        ...INITIAL_STATE,
      };
    //request
    case SET_INPUTS:
      return {
        ...state,
        [payload.key]: payload.value,
      };
    case GET_INVOICES_TRANSFER:
      return {
        ...state,
        invoicesTransfer: payload,
      }
    case SELECT_INVOICE_ID:
      return {
        ...state,
        invoiceId: payload,
      } 
    case CANCEL_INVOICE_TRANSFER:
      let deleteState = [...state.invoicesTransfer]
      const idx = deleteState.findIndex((invoice) => invoice.id === payload.id)
      if(idx === -1) return state
      deleteState[idx] = {
        ...deleteState[idx],
        status: 'ELIMINADO',
        url: payload.url
      }
      return {
        ...state,
        invoicesTransfer: deleteState
      }
    case SET_FORM_CANCEL_INVOICE: 
    return {
      ...state,
      formCancelInvoice: payload,
    }
    case SET_EMAIL_INVOICE:
    return {
      ...state,
      sendEmailInvoice: payload,
    }

    default:
      return state;
  }
}